import React from "react";
import { Aboutf1, Aboutf2, Aboutf3, Aboutf4 } from "../../asset/icons/Icons";

const AboutFeature = () => {
  return (
    <div className="about_feature container">
      <div className="about_feature_card">
        <Aboutf1 />
        <h4>
        Practical Knowledge
        </h4>
        <p>
        Our programs emphasize applied learning, where real-world projects turn concepts into expertise. We connect theory with practice so you gain insights that truly matter in your career.
        </p>
      </div>
      <div className="about_feature_card">
        <Aboutf2 />
        <h4>Transformative Mentorship</h4>
        <p>
        Guided by seasoned professionals, we go beyond conventional teaching—challenging norms, solving real problems, and unlocking opportunities that shape your professional growth.
        </p>
      </div>
      <div className="about_feature_card">
        <Aboutf3 />
        <h4>Tailored Learning</h4>
        <p>
        We recognize that every learner’s journey is unique. Our mentorship adapts to your goals, ensuring you gain skills that align with your aspirations and industry needs.
        </p>
      </div>
      <div className="about_feature_card">
        <Aboutf4 />
        <h4>
          Learn how we can <br /> power your growth
        </h4>
        <a href="">Contact Us</a>
      </div>
    </div>
  );
};

export default AboutFeature;
